// extracted by mini-css-extract-plugin
export default {"NoAccess":"index__NoAccess__GDmOq"};